export default "__VITE_ASSET__BSTzKMPo__"